module.exports = __webpack_public_path__ + "static/media/apefpi.ca86581e.png";